import { render } from "./Attend_2.vue?vue&type=template&id=d5b56070&scoped=true"
import script from "./Attend_2.vue?vue&type=script&lang=js"
export * from "./Attend_2.vue?vue&type=script&lang=js"

import "./Attend_2.vue?vue&type=style&index=0&id=d5b56070&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5b56070"]])

export default __exports__